<script>
import moment from 'moment'
moment.locale('hu')

export default {
  FMT_SHORT: 'short',
  formatDateTime (dt, dateFmt, timeFmt) {
    return dt ? moment(dt).format('L LT') : ''
  },
  duration (start, end) {
    var duration = moment.duration(moment(end).diff(moment(start)))
    return duration.humanize()
  },
  interval (start, end) {
    if (end) {
      return this.formatDateTime(end, this.FMT_SHORT, this.FMT_SHORT) +
        ' (időtartam: ' + this.duration(start, end) + ')'
    } else if (start) {
      return this.formatDateTime(start, this.FMT_SHORT, this.FMT_SHORT) + ' - ?'
    } else {
      return '-'
    }
  }
}
</script>



// WEBPACK FOOTER //
// i18n.vue?5c66b842